import UserActivityTable from 'components/tables/user-activity/UserActivityTable'
import React from 'react'

const index = () => {
    return (
        <UserActivityTable />
    )
}

export default index